import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import {
    useDomainesQuery, useExistSourceMutation,
    useProtocoleQuery,
    useZonesQuery,
} from '../../cdsApiSlice';
import { setSource, setProtocole } from '../../cdsSlice';
import { Domaine } from '../DomainManagement/CreateDomaine';
import { HandleDomaine } from '../HandleDomaines';
import RenderLoading from './RendorLoading';
import ButtonsNavigate from './BottomButtonNaviage';
import ErrorSourceExterne from './ErrorSourceExterne';


interface InfoGeneralProps {
    add: () => void;
}

interface Error {
    dataProduct: boolean;
    nom: {
        duplicateValue: boolean | undefined;
        regexNom: boolean;
        required: boolean;
    };
    description: boolean;
    protocole: boolean;
}

export const InfoGeneral = ({add}: InfoGeneralProps) => {
    const navigate = useNavigate();
    const {data: protocole, ...statusProtocole} = useProtocoleQuery();
    const [domainesData, setDomaineData] = useState<any>();
    const [dataSource, setDataSource] = useState<any>();
    const {data: domains, ...domaineStatus} = useDomainesQuery();
    const [handleDomaineDialog, setHandleDomaineDialog] = useState(false);
    const [domainesDialog, setDomainesDialog] = useState<boolean>(false);
    const [getExistSource,{data: dataExistSource, ...dataStatus}] = useExistSourceMutation();
    const dispatch = useAppDispatch();
    const source: any = useAppSelector((state) => state.cds.source);
    const {id} = useParams();
    const {data: zones} = useZonesQuery();
    const EMPTY_STRING = '';

    const [errorform, setError] = useState<Error>({
        dataProduct: false,
        nom: {
            duplicateValue: false,
            regexNom: false,
            required: false,
        },
        description: false,
        protocole: false,
    });


    const DomainesAndStockageTemplate = (option: any) => {
        return (
            <>
                {option.nom === 'Créer' && (
                    <div className={'LineDomaine mb-2'}></div>
                )}
                <div
                    style={{
                        color:
                            option.nom === 'Créer' ||
                            option.nom === 'Gérer les domaines' ||
                            option.nom === 'Ajouter'
                                ? '#009fdb'
                                : 'black',
                    }}
                >
                    {' '}
                    {option.nom}
                </div>
            </>
        );
    };


    useEffect(() => {
        if (protocole) {
            setDataSource(protocole.map((e: any) => ({nom: e.nom})));
            dispatch(setProtocole(protocole));
            const protocol = source.protocole ? source.protocole : protocole[0]?.nom;
            if(!id)dispatch(setSource({ protocole: protocol }));
        }
    }, [protocole]);

    useEffect(() => {
        if (domains && zones) {
            setDomaineData(() => {
                let tmp = domains.data.filter(domain => zones?.includes(domain.zone)).map((a: any) => ({
                    nom: a.libelle,
                    id: a.id
                })).sort((a, b) => a.nom.localeCompare(b.nom));
                tmp.push({nom: 'Créer', id: 'Créer'});
                // { nom: "Gérer les domaines",id:"Gérer les domaines" }
                return tmp;
            });
        }
    }, [domains, zones]);

    const errorSetter = (
        description: boolean,
        duplicateValue: boolean | undefined,
        required: boolean,
        regex: boolean,
        dataProduct: boolean,
        protocole: boolean
    ) => {
        setError({
            description: description,
            nom: {
                duplicateValue: duplicateValue,
                required: required,
                regexNom: regex,
            },
            dataProduct: dataProduct,
            protocole: protocole,
        });
    };

    const regexNom = (nomSource: string) => {
        const regex = /^[a-z0-9-]+$/;
        const CheckError: Error = errorform;

        if (nomSource !== EMPTY_STRING ) {
            CheckError.nom.regexNom = !nomSource.match(regex);
            CheckError.nom.required = false;
        }

        errorSetter(
            CheckError.description,
            CheckError.nom.duplicateValue,
            CheckError.nom.required,
            CheckError.nom.regexNom,
            CheckError.dataProduct,
            CheckError.protocole
        );
    };

    const check = async () => {
        let CheckError: Error = {...errorform}

        CheckError.dataProduct = !source.domaine;
        CheckError.protocole = source.protocole === null || source.protocole.trim() === EMPTY_STRING;
        CheckError.description = source.description.trim() === EMPTY_STRING;
        CheckError.nom.required = source.nom.trim() === EMPTY_STRING;

        try {
            const alreadyExists = await getExistSource({name: source.nom.trim()}).unwrap();

            CheckError.nom.duplicateValue = alreadyExists > 0 && !id;

    
            errorSetter(
                CheckError.description,
                CheckError.nom.duplicateValue,
                CheckError.nom.required,
                CheckError.nom.regexNom,
                CheckError.dataProduct,
                CheckError.protocole
            );
    
            const hasError = CheckError.dataProduct || CheckError.protocole || CheckError.description ||
                CheckError.nom.duplicateValue || CheckError.nom.required || CheckError.nom.regexNom;
    
            if (!hasError) {
                if (domainesData && typeof source.domaine === 'number') {
                    let tmpNom = {
                        id: source.domaine,
                        nom: domainesData.find((i: any) => i.id === source.domaine).nom,
                    };
                    dispatch(setSource({domaine: tmpNom}));
                }
                add();
            }
        } catch {
            CheckError.nom.duplicateValue = undefined;
            errorSetter(
                CheckError.description,
                CheckError.nom.duplicateValue,
                CheckError.nom.required,
                CheckError.nom.regexNom,
                CheckError.dataProduct,
                CheckError.protocole
            );
        }


    };


    const resetData = () => {
        dispatch(setSource({protocoleDatas: [], CustomMetaData: [], selectedLabels: {}}));
    };

    return (
        <>
            {
                domains &&
                <HandleDomaine
                    errorDialog={handleDomaineDialog}
                    setter={() => {
                        setHandleDomaineDialog(false);
                    }}
                    domaines={domains.data}
                />
            }
            <Domaine
                displayCreateDomaineDialog={domainesDialog}
                setter={() => {
                    setDomainesDialog(false);
                }}
                add={() => {
                    domaineStatus.refetch();
                }}
            />
            {(statusProtocole.isLoading ||
                domaineStatus.isLoading) && (
                <div className="contentForm">
                    <div className="formSourceExt mr-5">{RenderLoading(10)}</div>
                </div>
            )}
            {(statusProtocole.error || domaineStatus.error) &&
                !(
                    statusProtocole.isLoading ||
                    domaineStatus.isLoading
                ) && (
                    <div>
                        <ErrorSourceExterne message="Erreur de chargement"/>
                    </div>
                )}
            {domains && protocole && (
                <div className="contentForm">
                    <form className="formSourceExt">
                        <label
                            htmlFor="dataProduct"
                            className={classNames({
                                'p-error': errorform.dataProduct && source.domaine === null,
                                labelSourceExterne: true,
                            })}
                        >
                            Domaine<span className="star">*</span>
                        </label>
                        <Dropdown
                            id="dataProduct"
                            disabled={!!id}
                            value={source.domaine?.id ? source.domaine.id : source.domaine}
                            onChange={(e) => {
                                console.log(e);
                                if (e.value === 'Créer' || e.value === 'Gérer les domaines') {
                                    if (e.value === 'Créer') setDomainesDialog(true);
                                    if (e.value === 'Gérer les domaines')
                                        setHandleDomaineDialog(true);
                                } else {
                                    dispatch(setSource({domaine: e.value}));
                                }
                            }}
                            options={domainesData}
                            optionValue="id"
                            optionLabel="nom"
                            filter
                            className={classNames({
                                'p-invalid': errorform.dataProduct && source.domaine === null,
                                fieldSourceExt: true,
                            })}
                            itemTemplate={DomainesAndStockageTemplate}
                        />

                        <div className="mt-3">
                            <label
                                htmlFor="nom"
                                className={classNames({
                                    'p-error':
                                        errorform.nom.required ||
                                        errorform.nom.duplicateValue ||
                                        errorform.nom.duplicateValue === undefined ||
                                        errorform.nom.regexNom,
                                    labelSourceExterne: true,
                                })}
                            >
                                Nom de la source<span className="star">*</span>
                            </label>
                            <InputText
                                id={'nom'}
                                value={source.nom}
                                disabled={!!id}
                                className={classNames({
                                    'p-invalid':
                                        errorform.nom.required ||
                                        errorform.nom.duplicateValue ||
                                        errorform.nom.duplicateValue === undefined ||
                                        errorform.nom.regexNom,
                                    fieldSourceExt: true,
                                })}
                                onChange={(e) => {
                                    regexNom(e.target.value);
                                    dispatch(
                                        setSource({
                                            nom: e.target.value,
                                        })
                                    );
                                    // setName(e.target.value)
                                }}
                            />
                            <div>
                                { errorform.nom.duplicateValue && (
                                    <small className="p-error">
                                        Le nom de la source existe déja
                                    </small>
                                )}
                                { errorform.nom.duplicateValue === undefined && (
                                    <small className="p-error">
                                        Impossible de savoir si la source existe déjà, Veuillez contacter votre administrateur
                                    </small>
                                )}
                            </div>
                            <div>
                                {errorform.nom.regexNom && (
                                    <small className="p-error">
                                        Le nom de la source peut uniquement être composé de
                                        minuscules, chiffres et "-".
                                    </small>
                                )}
                            </div>
                        </div>

                        <div className="mt-3 mb-2">
                            <label
                                htmlFor="description"
                                className={classNames({
                                    'p-error': errorform.description && source.description.trim() === EMPTY_STRING,
                                    labelSourceExterne: true,
                                })}
                            >
                                Description de la source<span className="star">*</span>
                            </label>
                            <InputTextarea
                                id={'description'}
                                value={source.description}
                                className={classNames({
                                    'p-invalid':
                                        errorform.description && source.description.trim() === EMPTY_STRING,
                                    fieldSourceExt: true,
                                })}
                                onChange={(e) => {
                                    dispatch(
                                        setSource({
                                            description: e.target.value,
                                        })
                                    );
                                }}
                            />
                        </div>

                        <div className="mt-5">
                            <label
                                htmlFor="protocole"
                                className={classNames({
                                    'p-error': errorform.protocole && source.protocole === null,
                                    labelSourceExterne: true,
                                })}
                            >
                                Type de Source<span className="star">*</span>
                            </label>
                            <div className="grid p-fluid mt-2">
                                {dataSource && dataSource.map((data: any) => (
                                    <div className="col-2">
                                        <img
                                            src={require(`../../../../assets/images/select${data.nom}.svg`)}
                                            alt={data.nom}
                                            onClick={() => {
                                                if (source.protocole !== data.nom) {
                                                    dispatch(setSource({protocole: data.nom}));
                                                    resetData();
                                                }
                                            }}
                                            style={{
                                                border:
                                                    source.protocole === data.nom
                                                        ? "solid 3px #007eae"
                                                        : "solid 1px #d0ddea",
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>

                        </div>

                    </form>
                </div>
            )}

            <ButtonsNavigate
                cancel={() => {
                    navigate('/library/sources');
                }}
                back={() => {
                 navigate('/library/sources');
                }}
                shouldGoNext={domains && protocole}
                next={() => {
                 check();
                }}
            />
        </>
    );
};
